/**
 * @generated SignedSource<<789c1510ffdd021ac581120889a49ff1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SkillRow_skill$data = {
  readonly id: string;
  readonly name: string | null;
  readonly skillPersons: ReadonlyArray<{
    readonly person: {
      readonly id: string;
      readonly fullName: string | null;
      readonly active: boolean | null;
      readonly permissions: ReadonlyArray<string | null> | null;
      readonly profilePictureId: string | null;
    } | null;
    readonly level: {
      readonly id: string;
    } | null;
  } | null> | null;
  readonly " $fragmentType": "SkillRow_skill";
};
export type SkillRow_skill$key = {
  readonly " $data"?: SkillRow_skill$data;
  readonly " $fragmentSpreads": FragmentRefs<"SkillRow_skill">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SkillRow_skill",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SkillPerson",
      "kind": "LinkedField",
      "name": "skillPersons",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Person",
          "kind": "LinkedField",
          "name": "person",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fullName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "active",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "permissions",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profilePictureId",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SkillLevel",
          "kind": "LinkedField",
          "name": "level",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Skill",
  "abstractKey": null
};
})();

(node as any).hash = "9b18e980e4484d326a58beb7e51ea8a7";

export default node;
